import { render, staticRenderFns } from "./AdminLogout.vue?vue&type=template&id=6c0c71d9"
import script from "./AdminLogout.vue?vue&type=script&lang=js"
export * from "./AdminLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports